<template>
  <div class="widget">
    <h3>二手交易
      <router-link to="/oldstuff" class="more">更多&gt;</router-link>
    </h3>
    <div class="stuff-grid" style="margin: 0 -5px;">
      <div v-for="item in tableData" :key="item.oldstuff_id" style="width: 44%; margin: 0 3%; margin-bottom: 12px;">
        <router-link :to="`/oldstuffcontent/${item.oldstuff_id}`" style="display: block; border: 1px solid #e5e5e5; border-radius: 3px; overflow: hidden; background: #fff;">
          <img :src="item.oldstuff_img" style="width: 100%; height: 90px; object-fit: cover; display: block;" />
          <div style="padding: 6px 8px;">
            <div style="color: #e60000; font-weight: bold;">￥{{ item.oldstuff_price }}</div>
            <div style="font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.oldstuff_name }}</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getOldstuffList } from '@/api'

export default {
  name: 'OldstuffHotWidget',
  data() {
    return { tableData: [] }
  },
  created() {
    getOldstuffList({ page: 1, pagesize: 4 }).then((res) => {
      this.tableData = res.data || []
    })
  }
}
</script>
